export default __webpack_public_path__ + "static/media/My-Shows-Background.d1540c3f.png";